<template>
  <div style="margin: 0 16px 24px;">
    <p class="wallet" v-if="type == 1">充值总额：<span>{{ userWallet.payAllSum }}</span><span class="giveStyle" v-if="userWallet.payAllSum">（{{ userWallet.paySum }} + {{ userWallet.payGiveSum }}）</span></p>
    <p class="wallet" v-if="type == 2">抵扣总额：<span>{{ userWallet.dedSum }}</span></p>
    <p class="wallet" v-if="type == 3">总余额：<span>{{ userWallet.balanceAllSum }}</span><span class="giveStyle" v-if="userWallet.balanceAllSum">（{{ userWallet.balanceSum }} + {{ userWallet.balanceGiveSum }}）</span></p>
    <el-table
        ref="multipleTableRef"
        :data="pageDataList"
        style="width: 100%; "
        size="default"
        border
    >
      <el-table-column property="createTime" label="账户">
        <template #default="scope">
          <p v-if="type == 1">总充值金额</p>
          <p v-if="type == 2">总抵扣金额</p>
          <p v-if="type == 3">账户总余额</p>
        </template>
      </el-table-column>
      <el-table-column property="content" label="500账户">
        <template #default="scope">
          <p v-if="type == 1">{{scope.row.payOneAll}}<span class="giveStyle" v-if="scope.row.payOneAll">（{{scope.row.paySumOne}} + {{scope.row.paySumOneGive}}）</span></p>
          <p v-if="type == 2">{{scope.row.dedSumOne}}</p>
          <p v-if="type == 3">{{scope.row.balanceOneAll}}<span class="giveStyle" v-if="scope.row.balanceOneAll">（{{scope.row.balanceOne}} + {{scope.row.balanceOneGive}}）</span></p>
        </template>
      </el-table-column>
      <el-table-column property="content" label="1000账户">
        <template #default="scope">
<!--          <p v-if="type == 1">{{scope.row.paySumTwo}}</p>-->
<!--          <p v-if="type == 2">{{scope.row.paySumTwo - scope.row.balanceTwo}}</p>-->
<!--          <p v-if="type == 3">{{scope.row.balanceTwo}}</p>-->
          <p v-if="type == 1">{{scope.row.payTwoAll}}<span class="giveStyle" v-if="scope.row.payTwoAll">（{{scope.row.paySumTwo}} + {{scope.row.paySumTwoGive}}）</span></p>
          <p v-if="type == 2">{{scope.row.dedSumTwo}}</p>
          <p v-if="type == 3">{{scope.row.balanceTwoAll}}<span class="giveStyle" v-if="scope.row.balanceTwoAll">（{{scope.row.balanceTwo}} + {{scope.row.balanceTwoGive}}）</span></p>
        </template>
      </el-table-column>
      <el-table-column property="content" label="1500账户">
        <template #default="scope">
<!--          <p v-if="type == 1">{{scope.row.paySumThree}}</p>-->
<!--          <p v-if="type == 2">{{scope.row.paySumThree - scope.row.balanceThree}}</p>-->
<!--          <p v-if="type == 3">{{scope.row.balanceThree}}</p>-->
          <p v-if="type == 1">{{scope.row.payThreeAll}}<span class="giveStyle" v-if="scope.row.payThreeAll">（{{scope.row.paySumThree}} + {{scope.row.paySumThreeGive}}）</span></p>
          <p v-if="type == 2">{{scope.row.dedSumThree}}</p>
          <p v-if="type == 3">{{scope.row.balanceThreeAll}}<span class="giveStyle" v-if="scope.row.balanceThreeAll">（{{scope.row.balanceThree}} + {{scope.row.balanceThreeGive}}）</span></p>
        </template>
      </el-table-column>
      <el-table-column property="content" label="2500账户">
        <template #default="scope">
<!--          <p v-if="type == 1">{{scope.row.paySumFour}}</p>-->
<!--          <p v-if="type == 2">{{scope.row.paySumFour - scope.row.balanceFour  }}</p>-->
<!--          <p v-if="type == 3">{{scope.row.balanceFour}}</p>-->
          <p v-if="type == 1">{{scope.row.payFourAll}}<span class="giveStyle" v-if="scope.row.payFourAll">（{{scope.row.paySumFour}} + {{scope.row.paySumFourGive}}）</span></p>
          <p v-if="type == 2">{{scope.row.dedSumFour}}</p>
          <p v-if="type == 3">{{scope.row.balanceFourAll}}<span class="giveStyle" v-if="scope.row.balanceFourAll">（{{scope.row.balanceFour}} + {{scope.row.balanceFourGive}}）</span></p>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {add, Number_SubAll} from "@/assets/shared/util";

export default {
  name: "WalletDialog",
  props: {
    value: Object
  },
  data() {
    return {
      pageDataList: [],
      type: this.value.type,
      userWallet: this.value.userWallet,
    }
  },
  mounted() {

    this.userWallet.payOneAll = add([this.userWallet.paySumOne, this.userWallet.paySumOneGive])
    this.userWallet.payTwoAll = add([this.userWallet.paySumTwo, this.userWallet.paySumTwoGive])
    this.userWallet.payThreeAll = add([this.userWallet.paySumThree, this.userWallet.paySumThreeGive])
    this.userWallet.payFourAll = add([this.userWallet.paySumFour, this.userWallet.paySumFourGive])

    this.userWallet.balanceOneAll = add([this.userWallet.balanceOne, this.userWallet.balanceOneGive])
    this.userWallet.balanceTwoAll = add([this.userWallet.balanceTwo, this.userWallet.balanceTwoGive])
    this.userWallet.balanceThreeAll = add([this.userWallet.balanceThree, this.userWallet.balanceThreeGive])
    this.userWallet.balanceFourAll = add([this.userWallet.balanceFour, this.userWallet.balanceFourGive])

    this.userWallet.dedSumOne = Number_SubAll(this.userWallet.payOneAll, this.userWallet.balanceOneAll)
    this.userWallet.dedSumTwo = Number_SubAll(this.userWallet.payTwoAll, this.userWallet.balanceTwoAll)
    this.userWallet.dedSumThree = Number_SubAll(this.userWallet.payThreeAll, this.userWallet.balanceThreeAll)
    this.userWallet.dedSumFour = Number_SubAll(this.userWallet.payFourAll, this.userWallet.balanceFourAll)
    this.pageDataList.push(this.userWallet)
  }
}
</script>

<style scoped>
.wallet {
  font-size: 16px;
  font-weight: bolder;
  margin-bottom: 16px;
}
.wallet span {
  color: #3a8ee6;
}
.giveStyle {
  color: #aaaaaa !important;
}
</style>
